// If you add a feature, please document it with a general description and description of its effects when ennable and disable
const FEATURES_SWITCH = {
  // Define if users can use multiple blocks with the block parameter.
  // Enabled : allow users to display multiple block with a comma-seperated list of blocks
  // Disabled : even if users use a list of block, only the first one will be taken into account
  MULTIPLE_BLOCKS: true
};

type Feature = keyof typeof FEATURES_SWITCH;

export type { Feature };
export { FEATURES_SWITCH };
